const HINT_KEYS = [
  "applications",
  "application",
  "announcements",
  "announcement",
  "jobs",
  "job",
  "items",
  "results",
  "docs",
  "rows",
  "list",
];

function looksLikeRecord(item) {
  return item && typeof item === "object" && !Array.isArray(item);
}

export function extractCollection(payload, hints = HINT_KEYS) {
  if (Array.isArray(payload)) return payload;

  const seen = new Set();
  const queue = [payload];
  const hinted = [];
  const others = [];

  while (queue.length) {
    const current = queue.shift();
    if (!current || typeof current !== "object" || seen.has(current)) continue;
    seen.add(current);

    Object.entries(current).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        if (hints.includes(key)) hinted.push(value);
        else others.push(value);
        return;
      }
      if (value && typeof value === "object") queue.push(value);
    });
  }

  const candidates = [...hinted, ...others];
  return (
    candidates.find((list) => list.length && looksLikeRecord(list[0])) ||
    candidates.find((list) => Array.isArray(list)) ||
    []
  );
}

export function extractPagination(payload) {
  const sources = [
    payload?.pagination,
    payload?.meta,
    payload?.data?.pagination,
    payload?.data?.meta,
    payload?.data?.data?.pagination,
  ];
  return sources.find((item) => item && typeof item === "object") || {};
}
